import React, { useEffect, useState } from 'react'
import { ReactComponent as Icon } from "assets/img/warning.svg"

export default function AccountSusendedNotification(props) {
  const [errorMessage, setErrorMessage] = useState('')
  useEffect(() => {
    setErrorMessage(props.location.state.error.response?.data?.message)
  }, [])
  return (
    <div className="ug-cover">
      <div className="ug-welcome fadeIn">
        <span className="my-3"><Icon /></span>
        <div className="ug-title mb-2" style={{ fontSize: '16px' }}>
          {errorMessage} </div>
        <div className="ug-subtitle my-3" style={{ fontSize: '12px' }}>
          Please check your inbox for an email from support@kapitalwise.com. If you have any additional queries, feel free to reach out to us.
        </div>
      </div>
    </div>
  )
}
